<template>
  <div>
    <PersonalList :path="path" :filterPath="filterPath" @newPersonal='newPlayer' tituloTabla="Contratos de Jugadores"
      action-buttons-name="PlayersListActionButtons">
    </PersonalList>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newPlayer">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import PersonalList from '../components/PersonalList'

export default {
  components: {
    PersonalList
  },

  data () {
    return {
      path: 'players',
      filterPath: 'filters/players'
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddJugadores
    }
  },

  methods: {
    newPlayer () {
      this.$router.push({ name: 'nuevoJugador' })
    }
  }
}
</script>
